import messageController from './messageController'

export default messageController



// WEBPACK FOOTER //
// ../src/controllers/messageController/index.js